
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/giveback-2020",
      function () {
        return require("private-next-pages/giveback-2020.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/giveback-2020"])
      });
    }
  